import * as yup from 'yup'
import { Sector } from 'types/sector'

export interface SectorFormData {
    id: string | null
    name: string
    status: string
    transferSectorId?: string
}

export const createSectorSchema = (currentSectorId?: string | null, sectorsList?: Sector[], hasNotifications?: boolean | null) => yup.object({
    id: yup.string().nullable(),
    name: yup
        .string()
        .required('Nome do setor é obrigatório')
        .min(3, 'Nome deve ter pelo menos 3 caracteres')
        .max(100, 'Nome deve ter no máximo 100 caracteres')
        .trim()
        .test('unique-name', 'Setor já cadastrado nesta unidade', function(value) {
            if (!value || value.length < 3 || !sectorsList) return true
            
            // Se é edição, verificar se há outros setores com o mesmo nome (exceto o próprio)
            if (currentSectorId) {
                const duplicates = sectorsList.filter((sector: Sector) => 
                    sector.u_name?.toLowerCase() === value.toLowerCase() && 
                    sector.sys_id !== currentSectorId
                )
                return duplicates.length === 0
            }
            
            // Se é criação, verificar se há algum setor com o mesmo nome
            const duplicates = sectorsList.filter((sector: Sector) => 
                sector.u_name?.toLowerCase() === value.toLowerCase()
            )
            return duplicates.length === 0
        }),
    status: yup
        .string()
        .required('Status é obrigatório')
        .oneOf(['true', 'false'], 'Status deve ser ativo ou inativo'),
    transferSectorId: yup
        .string()
        .when('status', {
            is: 'false',
            then: (schema) => hasNotifications === true 
                ? schema.required('Setor de destino é obrigatório quando há notificações')
                : schema.optional(),
            otherwise: (schema) => schema.optional()
        })
})

export const sectorSchema = createSectorSchema(null, [], null)
